import { Injectable, inject } from "@angular/core";
import { RlHttpClient } from "../rl-http-client.service";
import { TaskConfig, TaskControlGroup } from "./task-config.models";

@Injectable({ providedIn: "root" })
export class TaskConfigService {
	private readonly _httpClient = inject(RlHttpClient);


	private _baseUrl = "/task-config";

	getTaskConfigurations(processId: number) {
		return this._httpClient
			.get(`${this._baseUrl}/${processId}`)
			.fetch<TaskConfig[]>();
	}

	getTaskConfiguration(id: number) {
		return this._httpClient
			.get(`${this._baseUrl}/detail/${id}`)
			.fetch<TaskConfig>();
	}

	createTaskConfig(task: TaskConfig) {
		return this._httpClient
			.post(`${this._baseUrl}`)
			.body(task)
			.fetch<TaskConfig>();
	}

	updateTaskConfig(task: TaskConfig) {
		return this._httpClient
			.put(`${this._baseUrl}/${task.id}`)
			.body(task)
			.fetch<void>();
	}

	deleteTaskConfig(taskConfigId: number) {
		return this._httpClient
			.delete(`${this._baseUrl}/${taskConfigId}`)
			.fetch<void>();
	}

	createTaskControlGroupConfig(taskControlGroup: TaskControlGroup) {
		return this._httpClient
			.post(`${this._baseUrl}/control-group`)
			.body(taskControlGroup)
			.fetch<{ id: number }>();
	}

	updateTaskControlGroupConfig(taskControlGroup: TaskControlGroup) {
		return this._httpClient
			.put(`${this._baseUrl}/control-group/${taskControlGroup.id}`)
			.body(taskControlGroup)
			.fetch<void>();
	}

	deleteTaskControlGroup(taskControlGroupId: number) {
		return this._httpClient
			.delete(`${this._baseUrl}/${taskControlGroupId}/task-set`)
			.fetch<void>();
	}
}